import React from 'react';
import { intlShape } from 'react-intl';
import { array, shape, bool } from 'prop-types';
import { PackageHeader, Box } from '@landtrustinc/design-system';

import useListingData from '../../../hooks/useListingData';
import useHeader from '../../../hooks/useHeader';
import { propTypes } from '../../../util/types';

const ListingHeaderSection = ({ listing, reviews, reviewsMeta, isFetchingReviews, intl }) => {
  const listingData = useListingData({ listing });

  const { header, subheader, features } = useHeader({
    data: listingData,
    reviews,
    reviewsMeta,
    isFetchingReviews,
    intl,
  });

  return (
    <Box width="100%">
      <PackageHeader header={header} subheader={subheader} features={features} />
    </Box>
  );
};

ListingHeaderSection.defaultProps = {
  reviews: [],
  reviewsMeta: null,
  isFetchingReviews: false,
};

ListingHeaderSection.propTypes = {
  listing: propTypes.listing.isRequired,
  reviews: array,
  reviewsMeta: shape({
    customerAverageRating: shape({}),
  }),
  isFetchingReviews: bool,
  intl: intlShape.isRequired,
};

export default ListingHeaderSection;
